export function addQueryParameter(url, name, value) {
  const joiningCharacter = url.indexOf('?') == -1 ? '?' : '&';
  const variantParam = `${name}=${value}`;
  return url + joiningCharacter + variantParam;
}
